const helperServiceVars =  {
	vars: {
		archetypes:  ['Caregiver', 'Creator', 'Everyman', 'Explorer', 'Hero', 'Innocent', 'Jester', 'Lover', 'Magician', 'Rebel', 'Ruler', 'Sage'],
		archetypeDefinitions: { // source https://www.scribophile.com/academy/what-are-jungian-archetypes#the-12-jungian-archetypes
			caregiver: 'This character is sometimes known as the Mother archetype, although they can be any gender or age. ' +
				'The Caregiver loves to look after people and to feel needed, and they’ll always lend an empathetic hand or ' +
				'ear to someone in trouble. They’re selfless, and put others’ needs before their own.',
			creator: 'Sometimes called the Artist, this character archetype delights in bringing order to chaos—whether that’s ' +
				'chaos out in the world or chaos within themselves—through creative endeavors like drawing, writing, music, ' +
				'architecture, or inventing new ways of doing things. They have a way of seeing things that others can’t, but ' +
				'have a tendency towards perfectionism and self-degradation.',
			everyman: 'The Everyman archetype is utterly normal in every way, while showing the best of what normal can be. ' +
				'They’re honest, authentic, non-confrontational, and believe that everyone deserves a fair shot. They’re down-to-earth ' +
				'and liked by just about everybody, but can easily be overlooked because they blend in so well.',
			explorer: 'The Explorer archetype suffers from a constant case of wanderlust. They’re dissatisfied with their tiny ' +
				'little world and long to see more of the world beyond. These characters are independent, self-motivated, and ' +
				'non-traditional, often straining against the cultural boundaries and stigmas of their society.',
			hero: 'The hero is out to change the world—but unlike the Rebel archetype, they often stumble onto their hero’s ' +
				'journey by accident. This character is brave (even if they don’t realize it at first), strong-spirited, and ' +
				'feels an instinctive need to protect those who are weaker than them.',
			innocent: 'The Innocent is the personification of positivity, sincerity, and purity. They embody the goodness ' +
				'of the world that other characters may have had to leave behind. They always see the best in others and believe ' +
				'in the possibility of a happy ending; due to either their youth or to a sheltered life, they’ve been untouched ' +
				'by the tragedies and hardships of the world.',
			jester: 'The Jester’s goal in life is to spread joy wherever they go, and often the easiest way to do this is ' +
				'through laughter. This character is the life of every party and always wants to make sure everyone’s having a ' +
				'good time, even to jester’s own detriment. They’re outspoken and often hit upon unexpected truths, but they can ' +
				'sometimes be superficial.',
			lover: 'The Lover archetype craves connection to others above all else, whether that’s with a partner, a dear ' +
				'friend, or a tight-knit family. Their strength lies in their inspiring hedonism—they use all of their senses ' +
				'to make the most out of every moment and believe in living life to the fullest.',
			magician: 'Also known as the Wizard archetype, this character has great power, knowledge, or skill. Their power ' +
				'may be supernatural, intellectual, or even practical, such as the ability to design complex computer systems. ' +
				'Their skills and knowledge often play a pivotal role in achieving the goals of a story.',
			rebel: 'Sometimes called the Revolutionary or the Outlaw, this character archetype doesn’t like the way the' +
				' world is and sets out to do something about it. They walk a very fine line between doing the wrong things' +
				' for the right reasons and losing themselves in the fight for their cause.',
			ruler: 'The Ruler is a natural born leader with big ambitions. They’re innately charismatic and have a knack for' +
				' understanding interpersonal politics, which allows them to easily exert their influence.',
			sage: 'The Sage is passionate about learning and is constantly working to improve their mind and spirit. They want ' +
				'to continually grow and understand the truth of everything, and they’re often a great person to come to for answers.' +
				' However, they can too easily lose themselves in studying minute details, and may be unwilling to trust themselves ' +
				'to take any real action, encouraging others to take action in their place.'
		},
		archetypePrompts: {
			caregiver: 'Focus on narratives that demonstrate compassion, altruism, and the importance of caring for others. Content should celebrate ' +
				'selflessness and the impact of nurturing on individual and community well-being',
			creator: 'Focus on creativity, imagination, and bringing new ideas to life, emphasizing the Creator\'s visionary nature and their relentless ' +
				'need for innovation, invention, and reinterpretation of the world around them. Content should celebrate the joy of creation and inspire ' +
				'others to express their unique vision and craft their reality. Showcase their role as pioneers in arts, technology, and creative expression. ' +
				'Express messages in surprisingly delightful ways.',
			everyman: 'Emphasize their relatability, normalcy, and unassuming nature. Content should highlight their deep connection to community and an ' +
				'innate desire for belonging, focusing on the simplicity and authenticity of their experiences. Celebrate the everyman’s values: genuine ' +
				'empathy, grounded charm, and an approachable lifestyle that resonates with the audience. This archetype embodies the essence of being part of a ' +
				'collective, sharing stories that reflect the common, yet unique, human journey, making them incredibly appealing and accessible to a wide audience',
			explorer: 'Craft content that captures their spirit of independence and thirst for adventure, highlighting their journey of self-discovery and ' +
				'personal freedom. Illustrate their unique path, marked by a desire to experience life beyond conventional boundaries, emphasizing their ' +
				'commitment to personal autonomy without explicitly naming it. Share stories that showcase the Explorer\'s ability to navigate the unknown, ' +
				'driven by an innate curiosity and a deep belief in following their own compass.',
			hero: 'Focus on crafting content that showcases their courage, bravery, and the relentless pursuit of success through mastery, accomplishment, ' +
				'and achievement. Narratives should celebrate the Hero\'s ability to overcome obstacles, highlighting their journey towards greatness and ' +
				'the fulfillment of their mission. Emphasize the power of their adventures, how they inspire others by setting examples of leadership, and ' +
				'their commitment to fighting for justice and protection. This archetype symbolizes the aspiration to rise above challenges, demonstrating ' +
				'the values of perseverance, excellence, and the impact of achieving one’s goals, thereby serving as a powerful source of motivation for the ' +
				'audience to pursue their own aspirations.',
			innocent: 'When crafting content, emphasize the inherent purity, unyielding optimism, and a strong sense of idealism that characterizes ' +
				'this archetype. This should reflect in narratives that portray a world where integrity and honesty prevail, where characters or subjects ' +
				'maintain a positive outlook despite challenges, and where there\'s a continuous pursuit of an ideal, untarnished world. Highlight stories ' +
				'or content that inspire the audience to believe in the goodness of people and the possibility of a perfect outcome through unwavering faith ' +
				'and moral clarity.',
			jester: 'Craft content that captures the essence of joy, humor, and the ability not to take life too seriously, promoting the value of ' +
				'playfulness and laughter. Integrate themes of irreverence, absurdity, and cleverness, highlighting the Jester\'s knack for seeing the ' +
				'world through a lens of happy and playful mischief. celebrate their unique talent for uplifting spirits and transforming ordinary experiences ' +
				'into extraordinary ones with their witty and joyful perspective',
			lover: 'Center content around passion, connection, and the appreciation of beauty in all forms, emphasizing the importance of relationships ' +
				'and emotional experiences. Add layers that delve into indulgence, things that delight the senses, intimacy, romance, sensuality, and ' +
				'hedonistic pleasures, portraying the Lover\'s deep-seated desire for experiences that fully engage the heart and senses.',
			magician: 'Create narratives that showcase transformation, vision, and the realization of possibilities, emphasizing their ability to deliver ' +
				'results that break the laws of the natural universe and make dreams come true. Highlight the Magician\'s unique skill in creating change ' +
				'and manifesting desires, often in ways that seem to transcend the possible, illustrating their role as the weaver of dreams and the architect ' +
				'of new realities. Content should inspire awe and wonder,',
			rebel: 'Create content that embodies defiance, innovation, and the breaking of conventions. Highlight stories of revolution and change, ' +
				'showcasing the Rebel\'s drive to disrupt the status quo for a better future.',
			ruler: 'Center content on leadership, stability, and the creation of a successful community, emphasizing themes of control, luxury, and being ' +
				'influential. Highlight the Ruler\'s association with superiority, status, and quality, portraying them as embodiments of sophistication, ' +
				'authority, and a commanding presence.',
			sage: 'Emphasize wisdom, insight, and the quest for truth, blending teaching, sharing information, and intelligence with analytical and ' +
				'contemplative depth. Highlight their dedication to knowledge, their capacity for deep analysis, and their philosophical outlook on life\'s ' +
				'intricate questions. Content should portray the Sage as both mentor and guide, inspiring others through intellectual depth and thoughtful ' +
				'reflection, serving as a beacon for clarity and enlightenment in a complex world'
		},
		intents: ['Evoke Emotion', 'Persuade', 'Inform'],
		hexColors: {
			orange: '#F0AD3D',
			peach: '#E88DA6',
			peachGradient: 'linear-gradient(225deg, #E77BC3 0%, #EBB85D 100%)',
			blue: '#6c8de1',
			green: '#74d9a4',
			red: '#e16c6c',
			white: '#fff',
			lightText: 'rgb(117, 118, 124)',
			darkText: '#5b6281',
			backgroundSecondary: '#0a0b10',
			webMainBackground: '#090910',
		},
		dallESpicyWords: ['bomb', 'slay'],
		colors: ['#6c8de1', '#6D94DB', '#6D9BD6', '#6EA2D0', '#6FA9CB', '#70B0C5', '#72C4B5', '#73CBAF', '#73D2AA', '#74D9A4'],
		graphColors : ['#ff7f0e', '#d62728', '#2ca02c', '#1f77b4', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
		richColors: [
			'#e672a9',
			'#e346ab',
			'#d33688',
			'#f1cbaf',
			'#ebb189',
			'#e59964',
			'#e08043',
			'#e46a66',
			'#6f4428',
			'#d1fcb8',
			'#b0e980',
			'#a6f779',
			'#5caf60',
			'#529d5e',
			'#29391c',
			'#83f4eb',
			'#7ae4f2',
			'#5eb2cc',
			'#4484a0',
			'#ccbcee',
			'#e672a9',
			'#b39be6',
			'#9979df',
			'#50406f'],
		logTypes: {
			LOGIN: {
				name: 'Login',
				color: ''
			},
			LOGIN_ERROR: {
				name: 'Login Error',
				color: '#b93232'
			},
			LOGOUT: {
				name: 'Logout',
				color: ''
			},
			BUG: {
				name: 'Submitted Bug',
				color: '#b96132'
			},
			GUIDE: {
				name: 'Opened Guide'
			},
			SETUP: {
				name: 'Setup Process'
			},
			SIGNUP: {
				name: 'Signup Process'
			},
			SCHEDULER: {
				name: 'Trigger Scheduler Process'
			},
		},
		envTypes: {
			PROD: 'prod',
			DEV: 'dev',
			LOCALHOST: 'localhost'
		},
		brandSpaces: [
			'Animals',
			'Art',
			'Beverages',
			'Books',
			'Business', // (catch all category for businesses that don't fit into the other categories - i.e. law firms, talent agencies, etc)
			'Cannabis',
			'Causes Activists Issues',
			'Consumer Electronics',
			'Convenience / Discount Stores',
			'Crafts & Hobbies',
			'Dance',
			'Design',
			'Digital Influencers',
			'Digital Platforms & Publishers',
			'Education',
			'Events',
			'Finance',
			'Fitness',
			'Food',
			'Gaming / Video Games',
			'Genres',
			'Home & Garden',
			'Humor & Comedy',
			'Local Government & Services',
			'Magazines',
			'Marketing',
			'Medical & Health',
			'Military',
			'Movies',
			'Music',
			'Nutrition',
			'On Camera Talent / Celebrities',
			'Parenting',
			'Personal Care',
			'Podcasts',
			'Politics',
			'Pop Culture & Fandom',
			'Radio',
			'Religion & Spirituality',
			'Science',
			'Sporting Goods',
			'Sports',
			'Style & Fashion',
			'Technology',
			'Toys',
			'Transportation',
			'Travel',
			'TV Content',
			'Venues',
			'Writers',
			'XXX / Pornography'
		],
		fonts: ['Arial', 'Times New Roman', 'Courier New', 'Georgia', 'Verdana',
			'Comic Sans MS',
			'Impact', 'Lucida Console', 'Tahoma', 'Trebuchet MS', 'Palatino Linotype',
			'Book Antiqua', 'Arial Black',
			'Arial Narrow', 'Arial Rounded MT Bold', 'Garamond', 'Courier', 'Lucida Sans Unicode'],
		tests: [{
			status: 'live',
			name: 'Post Card Button Placement',
			conditions: [
				{
					name: 'Top',
					default: true
				},
				{
					name: 'Bottom'
				}
			]
		}]
	}
}

export default helperServiceVars
